import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import type { SvgIconComponent } from '@mui/icons-material';
import { navTabGroupSx, navTabIconButtonSx, navTabLeadingIconSx, navTabSx } from './navTabStyles';

type NavTabProps = {
  to: string;
  label: string;
  icon: SvgIconComponent;
  active: boolean;
  iconOnly?: boolean;
  'aria-label'?: string;
};

const NavTab: React.FC<NavTabProps> = ({
  to,
  label,
  icon: Icon,
  active,
  iconOnly = false,
  'aria-label': ariaLabel,
}) => {
  if (iconOnly) {
    return (
      <Tooltip title={label}>
        <Button
          color="inherit"
          component={Link}
          to={to}
          aria-label={ariaLabel ?? label}
          sx={navTabIconButtonSx(active)}
        >
          <Icon />
        </Button>
      </Tooltip>
    );
  }

  return (
    <Button
      color="inherit"
      component={Link}
      to={to}
      aria-label={ariaLabel ?? label}
      sx={navTabSx(active)}
    >
      <Box component="span" sx={navTabGroupSx}>
        <Icon sx={navTabLeadingIconSx(active)} />
        <Typography>{label}</Typography>
      </Box>
    </Button>
  );
};

export default NavTab;
